import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 15l3 3l3 -3","key":"svg-0"}],["path",{"d":"M7 6v12","key":"svg-1"}],["path",{"d":"M14 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4","key":"svg-2"}],["path",{"d":"M17 14l-3.5 6h7l-3.5 -6","key":"svg-3"}]]

const IconSortAscendingShapes = createReactComponent('outline', 'sort-ascending-shapes', 'SortAscendingShapes', __iconNode);

export default IconSortAscendingShapes;